<template>
    <address-list scope="kulturplatz"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'KulturplatzList',

    components: {
        AddressList,
    },
};
</script>
